import * as util from 'node:util';
export default (obj) => util.types.isKeyObject(obj);
